import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getProductByPartNumber } from "../../services/catalogService";
import { trackEvent } from "../../services/analyticsService";
import SafeImage from "../common/SafeImage";
import "../../styles/ProductDetailPage.css";

const ProductDetailPage = () => {
  const { productNumber } = useParams();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchProductDetails = async () => {
      setLoading(true);
      setError(null);
      setProduct(null);

      try {
        const result = await getProductByPartNumber(productNumber);

        if (cancelled) return;

        if (!result || !result.product) {
          setError(`No product found for Part Number: ${productNumber}`);
          setLoading(false);
          return;
        }

        setProduct(result.product);
        trackEvent("view_product_detail", {
          product_number: result.product.productNumber,
          product_brand: result.product.brand,
        });
        setLoading(false);
      } catch (err) {
        if (cancelled) return;
        console.error("Error fetching product data:", err.message);
        setError(`Error loading product details: ${err.message}`);
        setLoading(false);
      }
    };

    fetchProductDetails();

    return () => {
      cancelled = true;
    };
  }, [productNumber]);

  if (loading) return <p>Loading product details...</p>;
  if (error) return <p>{error}</p>;
  if (!product) return <p>No product found for Part Number: {productNumber}</p>;

  const title = product.productTitle || "Untitled product";
  const imageSrc = product.mediumImagePath || product.smallImagePath || "";

  return (
    <section className="product-detail-page">
      <div className="product-image-container">
        <SafeImage src={imageSrc} alt={title} className="product-large-image" />
      </div>
      <div className="product-details">
        <h1>{title}</h1>
        <p>
          <strong>Part Number:</strong> {product.productNumber}
        </p>
        <p>
          <strong>Description:</strong> {product.urlSegment || "—"}
        </p>
        <button
          className="get-quote-button"
          onClick={() => {
            trackEvent("start_rfq", {
              product_number: product.productNumber,
              product_brand: product.brand,
            });
            window.location.href = "https://wa.me/+971504289825";
          }}
        >
          Get a Quote
        </button>
      </div>
    </section>
  );
};

export default ProductDetailPage;
